import { render, staticRenderFns } from "./MaterialFollowCraftList.vue?vue&type=template&id=c2f72f46&scoped=true"
import script from "./MaterialFollowCraftList.vue?vue&type=script&lang=js"
export * from "./MaterialFollowCraftList.vue?vue&type=script&lang=js"
import style0 from "./MaterialFollowCraftList.vue?vue&type=style&index=0&id=c2f72f46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f72f46",
  null
  
)

export default component.exports